import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
  textCustomSizeTypes,
  textCustomColorTypes,
  textCustomRadiusTypes,
  textAlignTypes,
} from '../../../../propertyValues';
import styles from './style';

const PaperWrapper = ({
  borderRadius,
  borderColor,
  borderSize,
  paper,
  align,
  children,
  className,
  onClick,
  style,
}) => {
  const useStyles = makeStyles(theme => styles(theme, align));
  const classes = useStyles();
  if (paper) {
    return (
      <Paper
        className={classnames(
          {
            [classes[`${borderSize}`]]: borderSize,
            [classes[borderColor]]: borderColor,
            [classes[borderRadius]]: borderRadius,
          },
          classes.paper,
          classes.align,
          classes.root,
          className,
        )}
      >
        {onClick ? (
          <div
            role="button"
            tabIndex={0}
            onClick={onClick}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick(e);
              }
            }}
          >
            {children}
          </div>
        ) : (
          <div>{children}</div>
        )}
      </Paper>
    );
  }
  return (
    <div
      className={classnames(
        {
          [classes[borderSize]]: borderSize,
          [classes[borderColor]]: borderColor,
          [classes[borderRadius]]: borderRadius,
        },
        classes.align,
        classes.root,
        className,
      )}
      style={style}
    >
      {onClick ? (
        <div
          role="button"
          tabIndex={0}
          onClick={onClick}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onClick(e);
            }
          }}
        >
          {children}
        </div>
      ) : (
        <div>{children}</div>
      )}
    </div>
  );
};

PaperWrapper.defaultProps = {
  borderColor: 'none',
  borderSize: 'none',
  borderRadius: 'none',
  paper: false,
  align: 'center',
};

PaperWrapper.propTypes = {
  borderSize: PropTypes.oneOf(textCustomSizeTypes),
  borderColor: PropTypes.oneOf(textCustomColorTypes),
  borderRadius: PropTypes.oneOf(textCustomRadiusTypes),
  align: PropTypes.oneOf(textAlignTypes),
  paper: PropTypes.bool,
};

export default PaperWrapper;
